import validation from './validation.js'
import general from '../general.js'
import store from '../../store.js'
var Dropzone = require('dropzone')

var createThumbnail = function (value, fileUrl, that) {
	return {
		init: async function () {
			// determine file size
			const resp = await fetch(fileUrl)
			const size = +resp.headers.get('Content-Length')

			// determine file extension
			const fileExtensionPattern = /\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/gmi
			const extension = fileUrl.match(fileExtensionPattern)[0]

			var mockFile = {
				name: value,
				dataURL: fileUrl,
				accepted: true,
				kind: 'image',
				size: size
			}

			if (!['.jpg', '.png', '.gif', '.jpeg'].includes(extension)) {
				// provide a default image to show in the dropzone
				mockFile.dataURL = '/assets/images/file-alt-regular.png'
			}

			that.files.push(mockFile)
			that.emit('addedfile', mockFile)

			that.createThumbnailFromUrl(mockFile, 100, null, 'contain', false, function (thumbnail) {
				that.emit('thumbnail', mockFile, thumbnail)
			}, 'Anonymous')

			that.emit('complete', mockFile)
		}
	}
}

var dropzoneConfig = function (el) {
	return {
		valuesArr: [],
		init: function () {
			this.el = el
			this.config = JSON.parse(this.el.getAttribute('data-config'))
			this.el.classList.add('dropzone-initialized')
			this.hiddenValueField = el.parentNode.querySelector('input[type=hidden]')
			this.locale = this.config.locale
			this.required = this.config.required

			this.setup()
		},

		setup: function () {
			Dropzone.autoDiscover = false
			var that = this
			var input = document.querySelector('[name="' + that.config.inputFieldName + '"]')

			var str = this.config.acceptedFiles
			var acceptedFiles = JSON.parse(str)

			// add convert image/jpeg to .jpg and .jpeg extensions in order to block .jfif and other jpg variants form being uploaded
			if (acceptedFiles.includes('image/jpeg')) {
				// add extensions
				acceptedFiles.push('.jpg')
				acceptedFiles.push('.jpeg')

				// remove mime type
				const index = acceptedFiles.indexOf('image/jpeg')
				acceptedFiles.splice(index, 1)
			}

			acceptedFiles = acceptedFiles.join()

			this.myDropzone = new Dropzone(this.el, {
				headers: {
					'Cache-Control': null,
					'X-Requested-With': null
				},
				addRemoveLinks: true,
				autoProcessQueue: false,
				uploadMultiple: true,
				parallelUploads: this.config.parallelUploads,
				maxFiles: parseInt(this.config.maxFiles) === 0 ? 100 : parseInt(this.config.maxFiles),
				paramName: 'file', // name of the file
				maxFilesize: this.config.maxFilesize,
				acceptedFiles: acceptedFiles,
				dictDefaultMessage: 'Drop it!',
				clickable: true,
				url: '/cms/api/upload?entity=' + this.config.entityName + '&prop=' + this.config.propertyName,
				init: function () {
					// dropzone created
					var val = input.value
					// catch cases where a json array is our value
					var valuesArr = []
					if (val) {
						if (val[0] === '[') {
							val = JSON.parse(val).join(',')
						}

						if (val !== '') {
							valuesArr = val.split(',')
						}
					}

					// prefill the already saved values
					if (valuesArr.length > 0) {
						for (var i = 0; i < valuesArr.length; i++) {
							var fileUrl = Object.keys(store.getters.project.domains)[0] + '/uploads/original/' + that.config.entityName + '/' + valuesArr[i]
							createThumbnail(valuesArr[i], fileUrl, this).init()
						}
					}
				},
				addedfile: function (file) {
					if (this.element === this.previewsContainer) {
						this.element.classList.add('dz-started')
					}

					// custom code for validation
					// add the name of our file to the hidden input field that will be submitted

					// crappy timeout because the accepted property is not known yet
					setTimeout(() => {
						if (file.accepted) that.valuesArr.push(file.name)
					}, 100)

					if (this.previewsContainer) {
						file.previewElement = Dropzone.createElement(this.options.previewTemplate.trim())
						file.previewTemplate = file.previewElement // Backwards compatibility

						this.previewsContainer.appendChild(file.previewElement)
						for (var node of file.previewElement.querySelectorAll('[data-dz-name]')) {
							node.textContent = file.name
						}
						for (node of file.previewElement.querySelectorAll('[data-dz-size]')) {
							node.innerHTML = this.filesize(file.size)
						}

						if (this.options.addRemoveLinks) {
							file._removeLink = Dropzone.createElement(`<a class='dz-remove' href='javascript:undefined;' data-dz-remove>${this.options.dictRemoveFile}</a>`)
							file.previewElement.appendChild(file._removeLink)
						}

						let removeFileEvent = e => {
							e.preventDefault()
							e.stopPropagation()
							if (file.status === Dropzone.UPLOADING) {
								return Dropzone.confirm(this.options.dictCancelUploadConfirmation, () => this.removeFile(file))
							} else {
								if (this.options.dictRemoveFileConfirmation) {
									return Dropzone.confirm(this.options.dictRemoveFileConfirmation, () => this.removeFile(file))
								} else {
									return this.removeFile(file)
								}
							}
						}

						for (let removeLink of file.previewElement.querySelectorAll('[data-dz-remove]')) {
							removeLink.addEventListener('click', removeFileEvent)
						}
					}
				},
				removedfile: function (file) {
					file.previewElement.remove()

					// remove filename from value field
					if (input.value !== '') {
						var values = []
						if (general.isJson(input.value)) {
							values = JSON.parse(input.value)
						} else {
							values.push(input.value)
						}

						// find index of deleted file in values
						var index = values.indexOf(file.name)
						if (index > -1) {
							// value is found, now we can delete them from the array and update the input field
							values.splice(index, 1)
							if (values.length === 0) {
								input.value = ''
							} else {
								input.value = JSON.stringify(values)
							}
						}
					}

					if (that.valuesArr.length > 0) {
						var index1 = that.valuesArr.indexOf(file.name)
						if (index1 > -1) that.valuesArr.splice(index, 1)
					}
				},
				error: function (file, response) {
					// add error class
					file.previewElement.classList.add('dz-error')
					var errorMessage = file.previewElement.querySelector('.dz-error-message span')
					errorMessage.innerText = response
				},
				successmultiple: function (file, response) {
					// if there already is a value we need to add those together
					var savedFile = response.data

					if (input.value) {
						var values = []
						if (general.isJson(input.value)) {
							values = JSON.parse(input.value)
						} else {
							values.push(input.value)
						}

						var newValues = values.concat(savedFile)
						input.value = JSON.stringify(newValues)
					} else {
						input.value = JSON.stringify(savedFile)
					}
				},
				completemultiple: function (file, response) {
					if (that.callback) that.callback()
				},
				reset: function () {
					this.removeAllFiles(true)
				}
			})
		},

		sendData: function (callback) {
			this.callback = callback

			// check if the field is empty
			if (this.myDropzone.getQueuedFiles().length > 0) {
				this.myDropzone.processQueue()
			} else {
				this.callback()
			}
		},

		setError: function () {
			validation._toggleError(false, this.el)
		},

		removeError: function () {
			validation._toggleError(true, this.el)
		},

		destroy: function () {
			// this only marks the instance as disabled and removes file arrays and event listeners
			this.myDropzone.disable()

			// to fully destroy this we will have to find the upload element and remove it
			var hiddenFileInput = this.myDropzone.hiddenFileInput

			// check if the input is wrapped in a container => this is not always the case
			var parent = hiddenFileInput.parentNode
			if (parent.classList.contains('uploader')) {
				parent.parentNode.removeChild(parent)
			} else {
				parent.removeChild(hiddenFileInput)
			}
		}
	}
}

export default dropzoneConfig
